import { mapActions, mapGetters } from "vuex";
import BaseTextDivider from "@/components/core/BaseTextDivider.vue";
import FormActions from "@/components/core/FormActions.vue";

export const formMixin = {
  components: {
    BaseTextDivider,
    FormActions
  },
  data() {
    return {
      formMixin_message: "",
      formMixin_loading: false
    };
  },
  computed: {
    ...mapGetters("auth", {
      formMixin_profile: "profile"
    })
  },
  watch: {
    formMixin_message(v) {
      this.$emit("message", v);
    },
    formMixin_loading(v) {
      this.$emit("loading", v);
    }
  },
  methods: {
    ...mapActions({
      formMixin_api: "api"
    }),
    formMixin_reset() {
      if (this.$refs.form) this.$refs.form.reset();
      if (this.$v) this.$v.$reset();
    },
    formMixin_getFormData: function(fields) {
      return this.$utils.buildForm(fields, this);
    },
    async formMixin_submit(fields, method, url) {
      this.formMixin_loading = true;
      this.formMixin_message = null;

      if (this.$v) {
        this.$v.$touch();
        if (this.$v.$invalid) {
          this.formMixin_loading = false;
          return false;
        }
      }

      try {
        const res = await this.formMixin_api({
          method,
          url,
          data: this.formMixin_getFormData(fields)
        });

        const data = this.$utils.parseResponse(res);

        this.formMixin_loading = false;
        this.$emit("submit-succeed", data);
        return { succeed: true, data };
      } catch (e) {
        const data = this.$utils.parseResponse(e);
        this.formMixin_message = data;
        this.formMixin_loading = false;
        this.$emit("submit-fail", data);
        return { succeed: false, data };
      }
    }
  }
};
